import {
  CustomMainRail,
  CustomSwiper,
  DeskBackgroundContent,
  MainPageBackgroundGradient,
  MainPanelWrap,
  MainRailWrap,
  MainSwiperWrapper,
  PointingTriangle,
  RailBackground,
  Title,
  WatchButton,
} from '../MainRailPage/MainRailPage.style'
import { RailItemMain } from '../RailItemMain/RailItemMain'
import { ILightRailItem } from '../../../types'
import { SwiperSlide } from 'swiper/react'
import router from 'next/router'
import { ottRoot } from '../../Api'
import { useEffect, useMemo, useState } from 'react'
import { SeparateRailWrap } from '../ComponentsFactory/ComponentsFactory.style'

const defaultBg = {
  desk: 'https://media3.reshet.tv/image/upload/v1709643070/uploads/2024/903961861.jpg',
  mob: 'https://media3.reshet.tv/image/upload/c_scale,q_auto:good,w_400/v1707813366/MobileOttBackground_dlhcon.png',
}
export const MainRail = ({
  id,
  swiperConfig,
  items,
}: {
  id: number
  swiperConfig: {}
  items?: ILightRailItem[]
}) => {
  const [bg, setBg] = useState({ desk: '', mob: '' })
  const [isMobile, setIsMobile] = useState<boolean>(false)
  const [opacity, setOpacity] = useState<0 | 1>(0)
  useEffect(() => {
    setTimeout(() => setOpacity(1), 0)
  }, [])
  const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState<{ width?: number }>({
      width: undefined,
    })

    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
        })
      }

      window.addEventListener('resize', handleResize)
      handleResize() // Initialize size at first component mount

      return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowSize
  }

  const { width } = useWindowSize()

  useEffect(() => {
    if (width && width <= 768) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [width])

  const first = useMemo(() => {
    if (items && items.length > 0) {
      return items[0]
    }
    return null
  }, [items])

  useEffect(() => {
    let { mob, desk } = defaultBg
    let found = first?.images.find(
      img => img.imageTypeName.trim() === 'Main_Desktop_Big_Background'
    )
    if (found) {
      desk = found?.url + '/width/1920/height/1080/quality/75'
    }
    found = first?.images.find(img =>
      [
        'Mobile_Main_Component_background _image',
        'Mobile_Main_Component_background_image',
      ].includes(img.imageTypeName.trim())
    )
    if (found) {
      mob = found?.url + '/width/516/height/619/quality/80'
    }
    setBg({ desk: desk, mob: mob })
  }, [first?.images])
  const liveChild = useMemo(() => {
    return (
      <>
        <Title>רשת 13 שידור חי</Title>
        <WatchButton
          onClick={() => router.push(`${ottRoot}/${first?.id || 2010263}`)}
        >
          <PointingTriangle /> לצפייה
        </WatchButton>
      </>
    )
  }, [first?.id])

  if (!items || items.length === 0) {
    return null
  }
  return (
    <MainRailWrap data-type={'main'}>
      <MainPageBackgroundGradient />
      <MainPanelWrap>
        <RailBackground key={id} desktopImage={bg.desk} mobileImage={bg.mob} />
        <DeskBackgroundContent>{liveChild}</DeskBackgroundContent>
        <DeskBackgroundContent display={'true'}>
          {liveChild}
        </DeskBackgroundContent>
        <MainSwiperWrapper>
          {isMobile ? (
            <SeparateRailWrap programWidth={90}>
              <CustomSwiper {...swiperConfig}>
                {items &&
                  items.map((r, i) => (
                    <SwiperSlide key={r.id}>
                      <RailItemMain
                        data={r}
                        isFirst={i === 0}
                        isLast={i === items.length - 1}
                      />
                    </SwiperSlide>
                  ))}
              </CustomSwiper>
            </SeparateRailWrap>
          ) : (
            <CustomMainRail opacity={opacity}>
              {items &&
                items.slice(0, 5).map((r, i) => (
                  <RailItemMain
                    key={r.id}
                    data={r}
                    isFirst={i === 0}
                    isLast={i === Math.min(4, items.length - 1)} // Ensure isLast is true for the last item in the visible list
                  />
                ))}
            </CustomMainRail>
          )}
        </MainSwiperWrapper>
      </MainPanelWrap>
    </MainRailWrap>
  )
}
